export interface Pagination {
  page: number;
  pageSize: number;
}

export const defaultPagination: Pagination = {
  page: 1,
  pageSize: 10,
};
